export const merchants = [
  {
    id: 1,
    key: 1,
    code: "001",
    name: "merchant name 1",
    company_name: "company name 1",
    other: "other 1",
  },
  {
    id: 2,
    key: 2,
    code: "002",
    name: "merchant name 2",
    company_name: "company name 2",
    other: "other 2",
  },
  {
    id: 3,
    key: 3,
    code: "003",
    name: "merchant name 3",
    company_name: "company name 3",
    other: "other 3",
  },
];

export const members = [
  {
    id: 1,
    key: 1,
    code: "001",
    name: "members name 1",
    phone_no: "09123456789",
    address: "Mandalay",
    points: 10,
  },
  {
    id: 2,
    key: 2,
    code: "002",
    name: "members name 2",
    phone_no: "09123456789",
    address: "Mandalay",
    points: 10,
  },
  {
    id: 3,
    key: 3,
    code: "003",
    name: "members name 3",
    phone_no: "09123456789",
    address: "Mandalay",
    points: 10,
  },
];

export const mockItems = [];

export const invoiceItems = [
  {
    id: 1,
    key: 1,
    item_code: "001",
    item_name: "ပုဆိုး",
    price: 1000,
    quantity: 10,
    subtotal: 10000,
  },
  {
    id: 2,
    key: 2,
    item_code: "002",
    item_name: "ပုဆိုး",
    price: 1000,
    quantity: 10,
    subtotal: 10000,
  },
  {
    id: 3,
    key: 3,
    item_code: "003",
    item_name: "ပုဆိုး",
    price: 1000,
    quantity: 10,
    subtotal: 10000,
  },
  {
    id: 4,
    key: 4,
    item_code: "004",
    item_name: "ပုဆိုး",
    price: 1000,
    quantity: 10,
    subtotal: 10000,
  },
  {
    id: 5,
    key: 5,
    item_code: "005",
    item_name: "ပုဆိုး",
    price: 1000,
    quantity: 10,
    subtotal: 10000,
  },
];

export const items = [
  {
    id: 1,
    code: "PD-001",
    name: "ပုဆိုး",
    price: 1000,
  },
  {
    id: 2,
    code: "PD-002",
    name: "ဖိနပ်",
    price: 2000,
  },
  {
    id: 3,
    code: "PD-003",
    name: "အင်္ကျီ",
    price: 3000,
  },
  {
    id: 4,
    code: "PD-004",
    name: "Product 4",
    price: 4000,
  },
  {
    id: 5,
    code: "PD-005",
    name: "Product 5",
    price: 4500,
  },
  {
    id: 6,
    code: "PD-006",
    name: "Product 6",
    price: 6000,
  },
  {
    id: 7,
    code: "PD-007",
    name: "Product 7",
    price: 7700,
  },
  {
    id: 8,
    code: "PD-008",
    name: "Product 8",
    price: 89000,
  },
  {
    id: 9,
    code: "PD-009",
    name: "Product 9",
    price: 9000,
  },
  {
    id: 10,
    code: "PD-0010",
    name: "Product 10",
    price: 10000,
  },
  {
    id: 11,
    code: "PD-0011",
    name: "Product 11",
    price: 1200,
  },
  {
    id: 12,
    code: "PD-0012",
    name: "Product 12",
    price: 4400,
  },
];